import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface SplashScreenProps {
  duration?: number; // duration in milliseconds
}

const SplashScreen = ({ duration = 2000 }: SplashScreenProps) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-white"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ 
            opacity: 0,
            transition: { 
              duration: 0.8,
              ease: "easeInOut"
            } 
          }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ 
              opacity: 1, 
              scale: 1,
              transition: { 
                duration: 0.5,
                ease: "easeOut"
              }
            }}
            exit={{ 
              opacity: 0, 
              scale: 1.2,
              transition: { 
                duration: 0.8,
                ease: "easeInOut"
              }
            }}
            className="w-64 h-64 flex items-center justify-center"
          >
            <img 
              src="/logo.png" 
              alt="Varsha Seeds" 
              className="w-auto h-auto max-w-full max-h-full" 
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SplashScreen;